import { Button } from "@/components/ui";
import type { AgentAnswer } from "@/lib/attributeReview/reviewRow.types";
import { cn } from "@/lib/utils";

import { box, muted } from "./agentStyles";

type Props = {
  name: string;
  copy: string;
  confidence: AgentAnswer["confidence"];
  fieldLabelOf: (id: string) => string;
  onCopy?: (copyOf: string) => void;
};

export function CopyAnswerCard({
  name,
  copy,
  confidence,
  fieldLabelOf,
  onCopy,
}: Props) {
  return (
    <div className={box}>
      <div className="flex items-start justify-between gap-2">
        <span className={cn("text-xs font-medium", muted)}>{name}</span>
        {confidence !== null && (
          <span className={cn("text-xs", muted)}>
            {Math.round(confidence * 100)}% sure
          </span>
        )}
      </div>
      <p className="text-[15px] font-semibold">Same as {fieldLabelOf(copy)}</p>
      <p className={cn("text-xs", muted)}>
        Hide this field. The seller answers once.
      </p>
      {onCopy && (
        <Button size="sm" variant="outline" onClick={() => onCopy(copy)}>
          Use this
        </Button>
      )}
    </div>
  );
}
